import { createRequest, RequestConfig } from 'app/common/api';

import { TTerminalConstraints } from '../core/terminal-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_terminals',
};

export const getTerminalsRequest = (constraints?: TTerminalConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
